import { CommonModule, NgIf, NgSwitch, NgSwitchCase, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostListener, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';
import { isMobile } from '@shared/utils/platform';

@Component({
  selector: 'ten-esg',
  templateUrl: './esg.component.html',
  styleUrls: ['./esg.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SafeHtmlPipe, TranslateModule, NgIf, MatIconModule, CommonModule, NgSwitch, NgTemplateOutlet, NgSwitchCase],
})
export class EsgComponent {
  public currentRoute;
  public isMobile = false;
  public esgContentClosed: boolean = true;
  @Input() public cardStyle: string;
  @Input() public showIcon: boolean = false;
  @Input() public showContent: boolean = false;
  @Input() public titleAboveContent: boolean = false;
  @Input() public esgTemplate: string;
  @HostListener('window:resize', ['$event'])
  public resize() {
    this.isMobile = isMobile();
  }

  constructor() {
    this.isMobile = isMobile();
  }

  public toggleEsgContent(): void {
    this.esgContentClosed = !this.esgContentClosed;
  }
}
